<template>
    <div class="toolbox-content">
        <div class="formItem">
            <label>E-Mail</label>
            <v-text-field solo flat hide-details class="sr-input" label="E-Mail" placeholder="E-Mail" autocomplete="off" v-model="value.mail"></v-text-field>
        </div>
        <!--
        <div class="formItem">
          <label>Vorname</label>
          <v-text-field solo flat hide-details class="sr-input" label="Vorname" placeholder="Vorname" v-model="value.firstName"></v-text-field>
        </div>
        <div class="formItem">
          <label>Nachname</label>
          <v-text-field solo flat hide-details class="sr-input" label="Nachname" placeholder="Nachname" v-model="value.lastName"></v-text-field>
        </div>
        -->
        <!--<image-upload :value="value.avatar" @input="value.avatarTmp=$event" @delete="value.avatarDelete=$event"></image-upload>-->
        <image-upload v-model="value.avatar.value" :label="value.avatar.label"></image-upload>

        <h3>Passwort ändern</h3>
        <div class="formItem">
            <label>Altes Passwort</label>
            <v-text-field
                    solo flat hide-details
                    :type="show1 ? 'text' : 'password'"
                    name="oldPass"
                    label="Altes Passwort"
                    placeholder="Altes Passwort"
                    v-model="value.oldPass"
                    class="sr-input"
                    @click:append="show1 = !show1"
            ></v-text-field>
        </div>
        <div class="formItem">
            <label>Neues Passwort</label>
            <v-text-field
                    solo flat hide-details
                    :type="show2 ? 'text' : 'password'"
                    name="newPass1"
                    label="Neues Passwort"
                    placeholder="Neues Passwort"
                    hint="mindestens 8 Zeichen"
                    v-model="value.newPass1"
                    class="sr-input"
                    @click:append="show2 = !show2"
            ></v-text-field>
        </div>
        <div class="formItem">
            <label>Neues Passwort wiederholen</label>
            <v-text-field
                    solo flat hide-details
                    :type="show3 ? 'text' : 'password'"
                    name="newPass2"
                    label="Neues Passwort wiederholen"
                    placeholder="Neues Passwort wiederholen"
                    hint="mindestens 8 Zeichen"
                    v-model="value.newPass2"
                    class="sr-input"
                    @click:append="show3 = !show3"
            ></v-text-field>
        </div>
    </div>
</template>

<script>
  import Dropzone from 'dropzone'

  Dropzone.autoDiscover = false
  export default {
    props: {
      value: {
        type: Object,
        required: true
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        show1: false,
        show2: false,
        show3: false
      }
    },
    methods: {
      closeToolbox () {
        this.$emit('close')
      }
    },
    computed: {}
  }
</script>

<style scoped>

</style>
